import React, { useState } from 'react';
import './InterviewForm.css';
import { useNavigate } from 'react-router-dom';

const InterviewFormStep1 = () => {
  const navigate = useNavigate();
  const BASE_URL = import.meta.env.VITE_APP_BASE_URL;
  const [interviewId, setInterviewId] = useState('')

  const handleSubmit = (e) => {
    navigate(`/start-interview/${interviewId}`)
  };

  const handleInputChange = (e) => {
    setInterviewId(e.target.value)
  };

  return (
    <div className="interview-container-form">
        <>
          <h1
            style={{
              color: "#000",
              fontSize: 22,
              marginBottom: 10,
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            Please Read Guidelines Carefully!
          </h1>
          <div className="guidelines-form">
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              <li >
                ✅ Your eye and facial movements will be monitored to detect any
                signs of misconduct during the interview.
              </li>
              <li>
                ✅ Ensure you are in a quiet environment with minimal
                distractions.
              </li>
              {/* <li>✅ Test your camera and microphone before the interview.</li> */}
              <li>❌ Do not change tabs or windows during the interview.</li>
              <li>
                ❌ Avoid using your phone or other devices during the interview.
              </li>
              <li>❌ Do not eat or drink during the interview.</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <label htmlFor="interviewId" style={{ display: 'block', marginBottom: '8px' }}>
              Enter Interview ID:
            </label>
            <input
              id="interviewId"
              type="text"
              minLength={24}
              maxLength={24}
              placeholder="e.g., 67b0db1bfb0fdbcaceeb7057"
              value={interviewId}
              onChange={handleInputChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "16px",
                marginBottom: "10px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                transition: "border-color 0.3s",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#5cb85c")}
              onBlur={(e) => (e.target.style.borderColor = "#ccc")}
            />
            <input
              type="submit"
              value={"Continue →"}
              style={{
                width: "100%",
                padding: "10px",
                backgroundColor: "#5cb85c",
                color: "white",
                border: "none",
                borderRadius: "4px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            />
          </form>
        </>
    </div>
  );
};

export default InterviewFormStep1;
